import React from 'react';
import './NotFound.css'
import logo from '../../images/maxresdefault.jpg'
const NotFound = () => {
    return (
        <div className='not'>
            <img src={logo} alt=""/>
        </div>
    );
};

export default NotFound;